import React, {useState} from 'react';

import TemplateCollectionSelector from 'notebook/entry-templates/collections/TemplateCollectionSelector';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Modal from 'ui-library/modals/Modal';

import {TemplateCollectionGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionGraphQL';

interface MoveToTemplateCollectionModalProps {
  title: string;
  initialTemplateCollectionId: string;
  onRequestSubmit: (templateCollectionId: string) => void;
  onRequestClose: () => void;
  allowedOwnerIds?: Array<string>;
}

export function MoveToTemplateCollectionModal(props: MoveToTemplateCollectionModalProps): JSX.Element {
  const [templateCollection, setTemplateCollection] = useState<string | TemplateCollectionGraphQL>(
    props.initialTemplateCollectionId
  );

  return (
    <Modal
      title={props.title}
      large={false}
      buttons={[
        {
          text: 'Move',
          submit: true,
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        if (
          typeof templateCollection !== 'string' &&
          templateCollection.id !== props.initialTemplateCollectionId
        ) {
          props.onRequestSubmit(templateCollection.id);
        } else {
          props.onRequestClose();
        }
      }}
    >
      <FieldLabel label="Template Collection" />
      <TemplateCollectionSelector
        value={templateCollection}
        onChange={(collection) => {
          setTemplateCollection(collection);
        }}
        allowedOwnerIds={props.allowedOwnerIds}
      />
    </Modal>
  );
}
